<app-card-header [header]="header"></app-card-header>

<br>
<app-camisa-trieur-card-I (mkCalc)="makeCalcCardII($event)"></app-camisa-trieur-card-I>
<br>
<app-camisa-trieur-card-II></app-camisa-trieur-card-II>
<br>
<app-camisa-trieur-card-III></app-camisa-trieur-card-III>
<br>
<app-camisa-trieur-card-IV></app-camisa-trieur-card-IV>
<br><br><br>



<div class="row">
    <div class="col-lg col-md col-xs col-sm col-xl cardAction text-right">
        <button mat-flat-button color="primary" class="iconFooter btnSize mt-2" matTooltip="Voltar"
            [routerLink]="['/camisa-trieur']">
            <i class="fa fa-undo fa-1x btnIcon"></i> Voltar
        </button>
        <ng-container *ngIf="!btnCollapse">
            <button mat-flat-button color="primary" class="iconFooter btnSize mt-2" matTooltip="Maximizar"
                (click)="collapseAll()">
                <i class="fa fa-window-maximize fa-1x btnIcon"></i> Maximizar
            </button>
        </ng-container>
        <ng-container *ngIf="btnCollapse">
            <button mat-flat-button color="primary" class="iconFooter btnSize mt-2" matTooltip="Minimizar"
                (click)="collapseAll()">
                <i class="fa fa-window-minimize fa-1x btnIcon"></i> Minimizar
            </button>
        </ng-container>
        <button mat-flat-button color="primary" class="iconFooter btnSize mt-2" matTooltip="Limpar" (click)="cleanAll()"
            [hidden]="!enableButtons | async">
            <i class="fa fa-paint-brush fa-1x btnIcon"></i> Limpar
        </button>
        <button mat-flat-button color="primary" class="iconFooter btnSize mt-2" matTooltip="Salvar" (click)="save()"
            [hidden]="!enableButtons | async">
            <i class="fa fa-floppy-o fa-1x btnIcon"></i> Salvar
        </button>
    </div>
</div>